<template>
  <div class="vue-tempalte">
    <form class="login-form" @submit="onSubmit">
      <!--<h3>Sign In</h3>-->
      <div class="form-group">
        <div><img class="login-logo" :src="logoLogin ? getImgUrl(logoLogin) : ''" /></div>
        <!--<div class="gie-logo"></div>-->
      </div>

      <div class="form-group">
        <label>Email</label>
        <input
          id="email"
          name="email"
          type="email"
          v-model="email"
          class="form-control form-control-lg"
          required
          autofocus
        />
      </div>

      <div class="form-group">
        <label>Contraseña</label>
        <input
          id="password"
          name="password"
          type="password"
          v-model="password"
          class="form-control form-control-lg"
          required
        />
      </div>

      <button type="submit" class="btn btn-dark btn-lg btn-block">
        Identificarse
      </button>

      <div class="form-group">
        <transition name="fade">
          <div
            v-if="show"
            class="bg-danger text-white text-center rounded"
            style="margin-top: 10px"
          >
           Email o contraseña incorrecta
          </div>
        </transition>
      </div>
    </form>

    <div class="representantes d-none d-xl-block">
     <p clas="text-center" style="margin-bottom:20px;margin-top:0px;font-size:0.8rem"> {{ footerLegend }}</p>
      <div align="middle" style="margin-top: 10px">
        <b-row>       
          <b-col v-if="logoCliente">
          <a :href="logoCliente.link" target="_blank" :title="logoCliente.title">
            <img
              class="logoFooter"
              style="height: 60px;margin-right:50px"
              :src="getImgUrl(logoCliente.img)"
              v-if="logoCliente.img"
            />
          </a>
          </b-col>          
          <b-col v-if="logoOrgano">
          <a :href="logoOrgano.link" target="_blank" :title="logoOrgano.title">
            <img 
              class="logoFooter"
              style="height: 60px;margin-right:50px"
              :src="getImgUrl(logoOrgano.img)"
              v-if="logoOrgano.img"
            />
          </a>
          </b-col>
          <b-col v-if="logoUS">
          <a :href="logoUS.link" target="_blank" :title="logoUS.title">
            <img
              class="logoFooter"
              style="height: 70px"
              :src="getImgUrl(logoUS.img)"
              v-if="logoUS.img"
            />
          </a>
          </b-col>
        </b-row>
      </div>      
    </div>

  </div>
</template>

<script>
import UserService from "@/services/UserService";
import Settings from "@/settings.js";


export default {
  data() {
    return {
      email: "",
      password: "",
      show: false,
      config: null,
      logoLogin: null,
      logoOrgano: {},
      logoUS: {},
      logoCliente: {},
      footerLegend: {}
    };
  },
  watch: {
    config: function(newVal, oldVal){
      //console.log(newVal)
      this.logoLogin = newVal.logoLogin
      this.logoOrgano = newVal.logoOrgano
      this.logoUS = newVal.logoUS
      this.logoCliente = newVal.logoCliente
      this.footerLegend = newVal.footerLegend      
    }
  },
  methods: {
    getImgUrl(image) {
      if(image){
         return require("@/assets/logos/" + image);
      }
    },

    onSubmit(e) {
      var self = this; // assign context to self variable - extremely important
      e.preventDefault();

      if (this.password.length > 0) {
        var data = {
          email: this.email,
          password: this.password,
        };

        UserService.login(data)
          .then((response) => {
            //Status means isAdmin here
            let status = response.data.user.status;
            localStorage.setItem("user", JSON.stringify(response.data.user));
            localStorage.setItem("jwt", response.data.token);

            //Si nos devuelve la API un token es que existe el usuario
            if (localStorage.getItem("jwt") != null) {
              this.$emit("loggedIn");
              if (this.$route.params.nextUrl != null) {
                this.$router.push(this.$route.params.nextUrl);
              } else {
                // TODO: Cambiar esta parte cuando se implementen los roles
                if (status == 1) {
                  //this.$router.push('admin')
                  //this.$router.push({ name: 'dashboard'})
                  this.$router.push({ name: "devices-zones" });
                } else {
                  this.$router.push({ name: "devices-zones" });
                }
              }
            }
          })
          .catch(function (error) {
            console.error(error.response);
            self.show = true;
            setTimeout(() => {
              self.show = false;
            }, 2000);
          });
      }
    },
  },
  async mounted() {
    this.config = await Settings;
  }
};
</script>

<style scoped>
.App {
  align-items: center;
  display: flex;
  justify-content: center;
}

.vertical-center {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.vue-tempalte {
  display: flex;
  text-align: left;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-color: #2554ff;
  box-shadow: none;
  height: 100vh;
}

.login-form {
  width: 450px;
  margin: auto;
  background: #ffffff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
  padding: 40px 55px 45px 55px;
  border-radius: 15px;
  transition: all 0.3s;
}

.navbar-light {
  background-color: #ffffff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
}

.form-control:focus {
  border-color: #2554ff;
  box-shadow: none;
}

.vertical-center h3 {
  text-align: center;
  margin: 0;
  line-height: 1;
  padding-bottom: 20px;
}
label {
  font-weight: 500;
}

.forgot-password,
.forgot-password a {
  text-align: right;
  font-size: 13px;
  padding-top: 10px;
  color: #7a7a7a;
  margin: 0;
}

.forgot-password a {
  color: #2554ff;
}

.social-icons {
  text-align: center;
  font-family: "Open Sans";
  font-weight: 300;
  font-size: 1.5em;
  color: #222222;
}
.social-icons ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.social-icons ul li {
  display: inline-block;
  zoom: 1;
  width: 65px;
  vertical-align: middle;
  border: 1px solid #e3e8f9;
  font-size: 15px;
  height: 40px;
  line-height: 40px;
  margin-right: 5px;
  background: #f4f6ff;
}

.social-icons ul li a {
  display: block;
  font-size: 1.4em;
  margin: 0 5px;
  text-decoration: none;
}
.social-icons ul li a i {
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  -ms-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}

.social-icons ul li a:focus i,
.social-icons ul li a:active i {
  transition: none;
  color: #222222;
}

.login-logo {
  /* Original value for background and size (AIC3) are 330x70px*/
  width: 330px;
  height: 87px;
  display: inline-block;
}

.gie-logo {
  background-image: url("~@/assets/logos/gie-logo.png");
  background-repeat: no-repeat;
  background-size: 165px 89px;
  width: 165px;
  height: 89px;
  display: inline-block;
}

.representantes {
  margin: auto;
  text-align: center;
  margin-top:-50px;
  background: #ffffff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
  padding: 20px 25px 25px 25px;
  border-radius: 15px;
  transition: all 0.3s;
}


.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
